import { createMuiTheme } from '@material-ui/core/styles';
import config from '../run-config';

const theme = createMuiTheme({
  typography: {
    fontSize: 12,
    htmlFontSize: 10,
    useNextVariants: true,
  },
  article: {
    quantityWidth: 38,
  },
  header: {
    height: 99,
    subheaderpanelHeight: 55,
  },
  order: {
    buttons: {
      fontSize: 18,
    },
  },
  appbar: {
    buttons: {
      fontSize: 18,
    },
  },
  palette: {
    primary: {
      main: config.primary,
      contrastText: config.primaryText,
    },
    secondary: { main: config.secondary },
    link: { main: config.link },
  },
});

export default theme;
